
import { useStaticQuery, graphql } from "gatsby"

function siteMetadata() {
  return useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author {
              name
            }
            socials {
              twitter
              twitterHandle
              github
              linkedin
              stackoverflow
              xing
            }
          }
        }
      }
    `
  )
}

export default siteMetadata
